/* global $ */

class MenuListItem {
  constructor($container) {
    this.$container = $container;
    this.namespace = this.$container.attr("data-namespace");
    this.$btnMain = this.$container.find(".BtnMenuListItem");
    this.$subBtns = [];

    this.$container.find(".BtnDropdownMenuItem").each((i, e) => {
      this.$subBtns.push($(e));
    });
  }
  setCurrent(namespace) {
    this.$btnMain.addClass("BtnMenuListItem--current");

    this.$subBtns.forEach(($item) => {
      if ($item.attr("data-namespace") == namespace) {
        $item.addClass("BtnDropdownMenuItem--current");
      } else {
        $item.removeClass("BtnDropdownMenuItem--current");
      }
    });
  }
  unsetCurrent() {
    this.$btnMain.removeClass("BtnMenuListItem--current");

    this.$subBtns.forEach(($item) => {
      $item.removeClass("BtnDropdownMenuItem--current");
    });
  }
}

class Header {
  constructor() {
    this.menuList = [];
    $(".MenuListItem").each((i, e) => {
      this.menuList.push(new MenuListItem($(e)));
    });
  }
  setCurrentPosition(namespace) {
    let parentNamespace = "";
    if (namespace.indexOf("culture") != -1) {
      parentNamespace = "culture";
    } else if (
      namespace.indexOf("services") != -1 ||
      namespace.indexOf("cases") != -1
    ) {
      parentNamespace = "services";
    } else if (namespace.indexOf("recruit") != -1) {
      parentNamespace = "recruit";
    } else if (
      namespace.indexOf("information") != -1 ||
      namespace.indexOf("news") != -1
    ) {
      parentNamespace = "information";
    }

    this.menuList.forEach((item) => {
      if (item.namespace == parentNamespace) {
        item.setCurrent(namespace);
      } else {
        item.unsetCurrent();
      }
    });
  }
}

export default Header;
